import { gql } from "@apollo/client";

export const OUT_OF_OFFICE_PERIODS = gql`
  query outOfOfficePeriods {
    outOfOfficePeriods {
      comments
      fromDate
      outOfOfficeReplacementId
      replaced
      replacedUserId
      replacement
      replacementUserId
      toDate
    }
  }
`;

export const REPLACEMENTS = gql`
  query replacements {
    replacements {
      id
      name
    }
  }
`;

export const USER_ID_QUERY = gql`
  query userInfo {
    userInfo {
      userId
    }
  }
`;
